import { render, staticRenderFns } from "./NewPageModal.vue?vue&type=template&id=7a6ac1b6&"
import script from "./NewPageModal.vue?vue&type=script&lang=js&"
export * from "./NewPageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports